<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Medical Alert Details</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="medicalForm">
        <fieldset>
            <div class="row">
                <div class="col-sm-5 mvd_form-group">
                    <label>Alert Type</label>
                    <select class="mvd_form-control" formControlName="customerIndividualMedicalAlertTypeId">
                        <option *ngFor="let alert of customerMedicalAlertTypes" value="{{alert.id}}">{{alert.displayValue}}</option>
                    </select>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Effective Date</label>
                    <p-calendar [showIcon]="true" formControlName="effectiveDate" [maxDate]="maxDate"></p-calendar>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="medicalForm.dirty && medicalForm.get('effectiveDate').hasError('required')">Effective date is required</div>
                        <div class="mvd_alert__rule" *ngIf="medicalForm.dirty && medicalForm.hasError('startAfterEndDate')">Effective date cannot be after End date</div>
                    </div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>End Date</label>
                    <p-calendar [showIcon]="true" formControlName="endDate"></p-calendar>
                </div>
                <div class="col-sm-1 mvd_form-group" *ngIf="medicalAlertId != 0">
                    <label>&nbsp;</label>
                    <a class="icon--delete" title="Delete Alert" href="javascript:void(0)" (click)="deleteMedicalAlert()"></a>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!(medicalForm.valid && medicalForm.dirty)" [isLoading]="showButtonLoading" [btnText]="'Save'" (clicked)="saveMedicalAlert()"></mvm-spinner-btn>
    </div>
</div>
